import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Header from '../../Header/Header';
import { history } from '../../helpers/history';

class celebrity extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bannerList: [],
            iframedrawurl: "",
            PromotionLaunch: [
                { "offertype": "LAUNCH EXTRAVAGANZA", "offer_quote": "Offer Lasts Only 3 Weeks After Launch.", "img_no": 5, "date": "offer", "url": "/PromotionRules" },
                { "offertype": "", "offer_quote": "We are thrilled to announce a significant change to our Super6 Raffle and Draw!", "img_no": 5, "date": "offer", "url": "/OfferSuper6" },
                { "offertype": "", "offer_quote": "We are thrilled to announce an exciting change to our raffle event! The Fortune4 Raffle is evolving into Fortune6, bringing even more opportunities for you to win incredible prizes!", "img_no": 5, "date": "offer", "url": "/Offerfortune6" },
            ],
            ViewPromotion: {}
        };
    }

    componentDidMount() {
        this.setjsondata()
    }


    setjsondata = () => {
        try {
            let hbanner = 0;
            let hbanner_old = localStorage.getItem('celebrityver');
            if (this.props.appvariables.bVersion) {
                let hbannerVer = this.props.appvariables.bVersion.split("~")
                if (hbannerVer.length > 2) {
                    hbanner = hbannerVer[2];//2
                }
            }
            if (hbanner_old != hbanner) { // hbanner_old != hbannertrue
                var s = process.env.REACT_APP_CDN_URL + 'web/celebrity.json' + "?V" + hbanner;
                fetch(s).then(response => response.json()).then(data => {
                    localStorage.setItem('celebrityverData', JSON.stringify(data.celebrity));
                    localStorage.setItem('celebrityver', hbanner);
                    this.setState({ Promotionrule: data.celebrity }); 
                })
            } else { 
                let CelebrityData = JSON.parse(localStorage.getItem('celebrityverData'));
                this.setState({ Promotionrule: CelebrityData }); 
            }
        }
        catch (ex) {
            console.log("setjsondata => ", ex)
        }
    };

    ClickPopup = (Obj) => {
        this.setState({ iframedrawurl: Obj.youtubeurl })
        if (window.LoadIframe) {
            setTimeout(() => {
                window.LoadIframe()
            }, 100);
        }
    }


    ClosePopup = () => {
        setTimeout(() => {
            this.setState({ iframedrawurl: "" })
        }, 300);
    }


    OfferDetails = (Obj) => {
        if (Obj && Obj.url) {
            history.push(Obj.url)
        }
    }

    SetOffer = (Obj) => {
        this.setState({ ViewPromotion: Obj })
    }

    render() {
        const { t } = this.props;
        return (
            <>

                <div class="myAccount">
                    <h2 class="headding1">{t('lblPromotion')} - {t('lblCelebrities')}</h2>
                    <div class="promotions-slide">
                        {this.state.Promotionrule && this.state.Promotionrule.map((x, inx) =>
                            <div class="promotionsLi">
                                <img src={`${process.env.REACT_APP_CDN_URL}/Web/Celebrity/${x.img_no}`} alt="" />
                                <div>
                                    <h3>{x.name}</h3>
                                    <p>{x._enterdate}</p>
                                </div>
                                <button className="loadiframe"><img onClick={() => { this.ClickPopup(x) }} src="./assets/img/icons/play.png?v0.2" /></button>
                            </div>
                        )}
                    </div>
                    {/* <div class="gradient-bar"></div> */}
                    {/* <h2 class="headding1 margin-top-20">{t('lblpromoresults')}</h2> */}
                    <div class="promoResults">
                        {/* <div class="promoResultsLft">
                            {this.state.PromotionLaunch && this.state.PromotionLaunch.map((x, inx) =>
                                <div class="promoRsltLftLi">
                                    <img src={`./assets/img/promotion/promotions-${x.img_no}.png?v0.1`} onClick={() => { this.SetOffer(x) }} />
                                    <div>
                                        <span>Offer</span>
                                        <h4>{x.offertype}</h4>
                                        <p>{x.offer_quote}</p>
                                        <a onClick={() => { this.OfferDetails(x) }}>{t('lblviewdetails')}</a>
                                    </div>
                                </div>
                            )}
                        </div> */}
                        {Object.keys(this.state.ViewPromotion) && Object.keys(this.state.ViewPromotion).length > 0 &&
                            <div class="promoResultsRht">
                                <div class="promoRsltRhtLi">
                                    <img src={`./assets/img/promotion/promotions-${this.state.ViewPromotion.img_no}.png?v0.1`} />
                                    <div>
                                        <h4>{this.state.ViewPromotion.offertype}</h4>
                                        <p>{this.state.ViewPromotion.offer_quote}</p>
                                        <a onClick={() => { this.OfferDetails(this.state.ViewPromotion) }}>{t('lblviewdetails')}</a>
                                    </div>
                                </div>
                            </div>}
                    </div>
                </div>



                {this.state.iframedrawurl && this.state.iframedrawurl.length > 0 && <>
                    <div class="promoBox" id='promoBox' style={{ display: "block" }}>
                        <div class="promoBoxWrap">
                            <a class="lightBoxClose" onClick={() => { this.ClosePopup() }} ><img src="./assets/img/icons/pop_close.png" /></a>
                            <iframe src={this.state.iframedrawurl + '&rel=0'} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                    </div>
                    <div style={{display:"block"}} onClick={() => { this.ClosePopup() }}  className="overlayLogin"></div>
                </>
                }




                {/* <div className="wrap2">
                    <h2 className="headding3 floatNone">{t('lblCelebrities')}</h2>
                    <div className="row mar40">
                        <div className="celebritSec">
                            {this.state.Promotionrule && this.state.Promotionrule.map((x, inx) =>
                                <>
                                    <div className="celebritSecCont">
                                        <div className="celebritImg">
                                            <img src={`${process.env.REACT_APP_CDN_URL}/Web/Celebrity/${x.img_no}`} alt="" />
                                            <p>{x.name}</p>
                                            <span>{x._enterdate}</span>
                                        </div>
                                        {((x.offertype && x.offertype.length > 0) || (x.offer_quote && x.offer_quote.length > 0)) && <div className="celebritDetails">
                                            <p>{x.offertype}</p>
                                            <span>{x.offer_quote}</span>
                                        </div>}
                                        <div className="celebritPlay bigpopupopen">
                                            <button><img src="./assets/img/icons/play.png?v0.1" onClick={() => { this.ClickPopup(x) }} alt="" srcset="" /></button>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>

                        <div className="popup-container bigpopup" id="popup-container1" >
                            <div className="popup-content !w-fit !min-w-min px-10 no-scrollbar">
                                <div className="rightAlign">
                                    <button className="close-popup crossBtn borderFade bigpopupclose" id="close-popup1" >
                                        <img src="./assets/img/icons/Close-Btn.svg" onClick={() => { this.ClosePopup() }} alt="Close Icon" />
                                    </button>
                                </div>
                                <div className="popup-main !px-8 flex justify-center items-center">
                                    <iframe
                                        width="700"
                                        height="455"
                                        src={this.state.iframedrawurl + '&rel=0'}
                                        title="YouTube video player"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowFullScreen
                                        className="rounded-md"
                                        style={{ border: "0px" }}
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            </>
        )
    }
}
function mapStateToProps(state) {
    const { appvariables } = state.loginReducer;
    return { appvariables };

}
export default connect(mapStateToProps)(withTranslation()(celebrity));